import { FormattedMessage } from "react-intl";
import styles from "./EmptyCart.module.scss";

function CartGraphic() {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 289 251">
      <path
        fill="#D2D9ED"
        fillOpacity=".4"
        d="M101.07 107.2c18.026 0 32.64-14.614 32.64-32.64 0-18.027-14.614-32.64-32.64-32.64-18.027 0-32.64 14.613-32.64 32.64 0 18.026 14.613 32.64 32.64 32.64ZM176.52 205.35c31.331 0 56.73-25.399 56.73-56.73 0-31.331-25.399-56.73-56.73-56.73-31.331 0-56.73 25.399-56.73 56.73 0 31.331 25.399 56.73 56.73 56.73Z"
      />
      <path
        stroke="#8FA1D2"
        strokeLinecap="round"
        strokeMiterlimit="10"
        strokeWidth="3"
        d="M250 102.56v15.28"
      />
      <path
        stroke="#425B9F"
        strokeLinecap="round"
        strokeMiterlimit="10"
        strokeWidth="3"
        d="M250 125.91v25.29M143.17 64.23H63.16M286.63 51.51h-18.81M278.27 30.91l-13.3 13.3M257.87 21.5v18.81"
      />
      <path
        fill="#D0D7EB"
        d="M94.83 250.49c7.124 0 12.9-5.775 12.9-12.9 0-7.124-5.776-12.9-12.9-12.9-7.125 0-12.9 5.776-12.9 12.9 0 7.125 5.775 12.9 12.9 12.9Z"
      />
      <path
        fill="#8FA1D2"
        d="M94.83 243.83a6.24 6.24 0 1 0 0-12.48 6.24 6.24 0 0 0 0 12.48Z"
      />
      <path
        fill="#D0D7EB"
        d="M189.42 250.49c7.124 0 12.9-5.775 12.9-12.9 0-7.124-5.776-12.9-12.9-12.9-7.125 0-12.9 5.776-12.9 12.9 0 7.125 5.775 12.9 12.9 12.9Z"
      />
      <path
        fill="#8FA1D2"
        d="M189.42 243.83a6.24 6.24 0 1 0 0-12.48 6.24 6.24 0 0 0 0 12.48ZM243.45 170.19V75.55c0-2.79-2.27-5.07-5.07-5.07H41.27l-.1-.5-2.59-28.67c-.07-.78-.6-1.43-1.35-1.65L1.89 29.07c-.14-.04-.28-.06-.42-.06-.24 0-.47.06-.69.18-.35.19-.6.5-.71.87-.23.77.21 1.59.99 1.82L34.5 41.89c.75.22 1.28.87 1.35 1.65l15.5 171.7a4.664 4.664 0 0 0 4.67 4.26h161.96c.8 0 1.5-.55 1.6-1.25.06-.43-.06-.85-.34-1.18-.28-.32-.68-.51-1.11-.51H56.11c-.97 0-1.78-.73-1.86-1.7l-1.13-12.52c-.1-1.06.65-1.99 1.7-2.14l184.29-25.05c2.47-.34 4.34-2.47 4.34-4.97v.01ZM75.1 194.49l-18.42 2.5a3.067 3.067 0 0 1-3.47-2.74L41.84 76.62a2.933 2.933 0 0 1 2.91-3.21h20.31c1.15 0 2.09.86 2.2 2l10.84 115.3a3.468 3.468 0 0 1-3 3.78Zm42.31-5.75L83.9 193.3c-.12.02-.23.02-.34.02-.56 0-1.1-.19-1.55-.54-.54-.43-.87-1.04-.93-1.72L70.3 76.33c-.07-.74.18-1.49.68-2.04s1.22-.87 1.97-.87h35.91c1.36 0 2.5 1.06 2.6 2.41l8.12 110.25c.1 1.31-.85 2.48-2.16 2.66h-.01Zm41.63-5.66-33.82 4.6a2.469 2.469 0 0 1-1.87-.52 2.46 2.46 0 0 1-.9-1.72l-8.04-109.17c-.05-.73.2-1.47.7-2 .5-.54 1.21-.85 1.95-.85h35.93c1.39 0 2.53 1.08 2.6 2.47l5.55 104.65c.07 1.26-.86 2.38-2.11 2.55l.01-.01Zm42.87-7.78c0 .97-.73 1.81-1.69 1.95l-33.74 4.82c-.1.01-.2.02-.3.02a2.115 2.115 0 0 1-2.11-2l-5.49-103.56c-.04-.82.24-1.59.81-2.19.56-.59 1.32-.92 2.14-.92h37.43c1.63 0 2.95 1.33 2.95 2.95v98.94-.01Zm38.61-5.11c0 1.04-.77 1.92-1.8 2.06l-31.42 4.27c-.1.01-.2.02-.29.02a2.175 2.175 0 0 1-2.17-2.17v-98c0-1.63 1.33-2.95 2.95-2.95h30.59c1.18 0 2.13.96 2.13 2.13v94.64h.01Z"
      />
      <path
        fill="#3BBAE3"
        d="M239.95 90.87c13.603 0 24.63-11.027 24.63-24.63 0-13.602-11.027-24.63-24.63-24.63-13.602 0-24.63 11.028-24.63 24.63 0 13.603 11.028 24.63 24.63 24.63Z"
      />
      <path
        fill="#fff"
        d="M246.79 66.02c0 6.85-2.54 10.64-7.01 10.64-3.94 0-6.61-3.69-6.67-10.36 0-6.76 2.92-10.48 7.01-10.48s6.67 3.78 6.67 10.2Zm-10.95.31c0 5.24 1.61 8.22 4.09 8.22 2.79 0 4.12-3.26 4.12-8.4 0-5.14-1.27-8.22-4.09-8.22-2.39 0-4.12 2.92-4.12 8.4Z"
      />
      <path
        fill="#D2D9ED"
        fillOpacity=".4"
        d="M167.5 31c8.56 0 15.5-6.94 15.5-15.5C183 6.94 176.06 0 167.5 0 158.94 0 152 6.94 152 15.5c0 8.56 6.94 15.5 15.5 15.5Z"
      />
    </svg>
  );
}

export default function EmptyCart() {
  return (
    <div className={styles.emptyCart}>
      <CartGraphic />
      <FormattedMessage defaultMessage="My Cart is Empty" tagName="h2" />
      <FormattedMessage
        defaultMessage='You can shop for course materials by selecting "Purchase Options" on eligible books or by visiting your bookstore.'
        tagName="p"
      />
    </div>
  );
}
